import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get} from '../../modules/inventory/additionalFuelAllocation';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const additionalFuelAllocationId = _.get(ownProps, ['match', 'params', 'additionalFuelAllocationId']);
	const additionalFuelAllocation = (additionalFuelAllocationId)
		? _.get(state.maps, ['additionalFuelAllocation', additionalFuelAllocationId])
		: undefined;

	return {
		additionalFuelAllocation,
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	addAdditionalFuelAllocation : add,
	updateAdditionalFuelAllocation : update,
	getAdditionalFuelAllocation : get,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
